'use client';
import { useState } from 'react';
import { Wrench, Settings2, Link as LinkIcon, CheckSquare, ChevronDown, User, ShoppingCart, DollarSign, CheckCircle2, Square, Info } from 'lucide-react';
import styles from './ServicosModule.module.css';

export function ServicosModule({ reverse = false }: { reverse?: boolean }) {
  const [activeMockup, setActiveMockup] = useState('painel');

  const getCardStyle = (isActive: boolean) => ({
    display: 'flex', gap: '1.25rem', alignItems: 'flex-start', padding: '1.25rem',
    borderRadius: '16px', cursor: 'pointer', transition: 'all 0.2s',
    border: isActive ? '1px solid var(--md-sys-color-primary)' : '1px solid #e2e8f0',
    background: isActive ? 'color-mix(in srgb, var(--md-sys-color-primary) 5%, transparent)' : 'white',
    boxShadow: isActive ? '0 4px 12px rgba(245,124,0,0.05)' : '0 2px 4px rgba(0,0,0,0.02)'
  });

  return (
    <div style={{ display: 'flex', flexDirection: reverse ? 'row-reverse' : 'row', gap: '4rem', alignItems: 'center', flexWrap: 'wrap' }}>
      
      {/* TEXTO E CARDS DE SELEÇÃO */}
      <div style={{ flex: '1 1 450px', display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
        <div>
          <span style={{background: '#fef3c7', color: '#b45309', padding: '6px 16px', borderRadius: '50px', fontSize: '0.8rem', fontWeight: 800, textTransform: 'uppercase', letterSpacing: '0.5px'}}>
            Ordens de Serviço
          </span>
          <h3 style={{ fontSize: '2.5rem', fontWeight: 800, color: '#0f172a', margin: '1.5rem 0 1rem 0', lineHeight: 1.2 }}>
            O Braço Direito das Assistências
          </h3>
          <p style={{ fontSize: '1.1rem', color: '#64748b', lineHeight: 1.6 }}>
            Do recebimento do equipamento à entrega. Crie formulários personalizados para o seu nicho, vincule peças do estoque e gere faturamentos no financeiro automaticamente.
          </p>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', marginTop: '1rem', maxHeight: '550px', overflowY: 'auto', paddingRight: '8px' }}>
          
          <div style={getCardStyle(activeMockup === 'painel')} onClick={() => setActiveMockup('painel')}>
            <Wrench size={28} style={{ color: '#f59e0b', flexShrink: 0, marginTop: '2px' }} />
            <div>
              <h4 style={{ margin: '0 0 4px 0', fontSize: '1.05rem', color: '#1e293b', fontWeight: 700 }}>Gerenciar Ordens (OS)</h4>
              <p style={{ margin: 0, fontSize: '0.9rem', color: '#64748b', lineHeight: 1.4 }}>Crie, edite e acompanhe os status das OS abertas, em andamento e concluídas em um painel claro.</p>
            </div>
          </div>
          
          <div style={getCardStyle(activeMockup === 'form')} onClick={() => setActiveMockup('form')}>
            <Settings2 size={28} style={{ color: '#3b82f6', flexShrink: 0, marginTop: '2px' }} />
            <div>
              <h4 style={{ margin: '0 0 4px 0', fontSize: '1.05rem', color: '#1e293b', fontWeight: 700 }}>Formulários Personalizados</h4>
              <p style={{ margin: 0, fontSize: '0.9rem', color: '#64748b', lineHeight: 1.4 }}>Crie atributos únicos (ex: IMEI para celulares, Placa para carros) dependendo do equipamento.</p>
            </div>
          </div>

          <div style={getCardStyle(activeMockup === 'integracao')} onClick={() => setActiveMockup('integracao')}>
            <LinkIcon size={28} style={{ color: '#10b981', flexShrink: 0, marginTop: '2px' }} />
            <div>
              <h4 style={{ margin: '0 0 4px 0', fontSize: '1.05rem', color: '#1e293b', fontWeight: 700 }}>Integração de Vendas</h4>
              <p style={{ margin: 0, fontSize: '0.9rem', color: '#64748b', lineHeight: 1.4 }}>Adicione peças diretamente do módulo de Vendas e transforme a OS em uma cobrança no Financeiro.</p>
            </div>
          </div>

          <div style={getCardStyle(activeMockup === 'checklist')} onClick={() => setActiveMockup('checklist')}>
            <CheckSquare size={28} style={{ color: '#8b5cf6', flexShrink: 0, marginTop: '2px' }} />
            <div>
              <h4 style={{ margin: '0 0 4px 0', fontSize: '1.05rem', color: '#1e293b', fontWeight: 700 }}>Checklist e Anotações</h4>
              <p style={{ margin: 0, fontSize: '0.9rem', color: '#64748b', lineHeight: 1.4 }}>Monte checklists obrigatórios para os técnicos e deixe notas internas ocultas do cliente.</p>
            </div>
          </div>

        </div>
      </div>

      {/* MOCKUP DESKTOP (DIREITA) */}
      <div style={{ flex: '1 1 450px', width: '100%', minWidth: 0 }}>
        <div className={styles.mockupContainer}>
          <div className={styles.desktopMockup}>
            
            {/* Barra do App */}
            <div className={styles.browserBar}>
              <div className={styles.dots}><span></span><span></span><span></span></div>
              <div className={styles.addressBar}>
                painel.aesirerp.com/os/{activeMockup}
              </div>
            </div>

            {/* Corpo do Dashboard */}
            <div className={styles.dashboardBody}>
              
              {/* 1. Painel de Gerenciamento */}
              {activeMockup === 'painel' && (
                <div className={styles.osList}>
                  <div className={styles.osCard}>
                    <div className={styles.osHeader}>
                      <span className={styles.osNumber}>OS #1042</span>
                      <span className={styles.osDate}>Hoje, 09:15</span>
                    </div>
                    <div className={styles.osTitle}>Troca de Tela - iPhone 13</div>
                    <div className={styles.osClient}><User size={12}/> Cliente: Marcos Silveira</div>
                    <div className={styles.osFooter}>
                      <span className={`${styles.osStatus} ${styles.statusProgress}`}>EM ANDAMENTO</span>
                      <span className={styles.osPrice}>R$ 450,00</span>
                    </div>
                  </div>

                  <div className={styles.osCard}>
                    <div className={styles.osHeader}>
                      <span className={styles.osNumber}>OS #1043</span>
                      <span className={styles.osDate}>Ontem, 14:20</span>
                    </div>
                    <div className={styles.osTitle}>Limpeza Preventiva - Ar Cond. 12k BTUs</div>
                    <div className={styles.osClient}><User size={12}/> Cliente: Clínica Sorriso</div>
                    <div className={styles.osFooter}>
                      <span className={`${styles.osStatus} ${styles.statusOpen}`}>AGUARDANDO PEÇA</span>
                      <span className={styles.osPrice}>--</span>
                    </div>
                  </div>

                  <div className={styles.osCard}>
                    <div className={styles.osHeader}>
                      <span className={styles.osNumber}>OS #1040</span>
                      <span className={styles.osDate}>18 Abr, 11:00</span>
                    </div>
                    <div className={styles.osTitle}>Formatação e Backup - Notebook Dell</div>
                    <div className={styles.osClient}><User size={12}/> Cliente: Ana Paula</div>
                    <div className={styles.osFooter}>
                      <span className={`${styles.osStatus} ${styles.statusDone}`}>CONCLUÍDO</span>
                      <span className={styles.osPrice}>R$ 150,00</span>
                    </div>
                  </div>
                </div>
              )}

              {/* 2. Formulários e Atributos Dinâmicos */}
              {activeMockup === 'form' && (
                <div className={styles.customForm}>
                  <div className={styles.formSelector}>
                    <span>Tipo de Equipamento: <strong>Smartphone</strong></span>
                    <ChevronDown size={16} />
                  </div>
                  
                  <div className={styles.formGrid}>
                    <div className={styles.formField}>
                      <span className={styles.fieldLabel}>Marca</span>
                      <div className={styles.fieldInput}>Apple</div>
                    </div>
                    <div className={styles.formField}>
                      <span className={styles.fieldLabel}>Modelo</span>
                      <div className={styles.fieldInput}>iPhone 13 Pro</div>
                    </div>
                    <div className={`${styles.formField} ${styles.full}`}>
                      <span className={styles.fieldLabel}>IMEI / Serial (Atributo Customizado)</span>
                      <div className={styles.fieldInput}>359980001234567</div>
                    </div>
                    <div className={`${styles.formField} ${styles.full}`}>
                      <span className={styles.fieldLabel}>Defeito Relatado</span>
                      <div className={styles.fieldInput} style={{minHeight: '60px'}}>Tela trincada no canto superior e touch falhando às vezes.</div>
                    </div>
                  </div>
                </div>
              )}

              {/* 3. Integração (Vendas + Financeiro) */}
              {activeMockup === 'integracao' && (
                <div className={styles.integrationCard}>
                  
                  <div className={styles.sectionTitle}>
                    <ShoppingCart size={16} color="#3b82f6"/> Peças e Serviços Adicionados
                  </div>
                  
                  <div className={styles.partsList}>
                    <div className={styles.partItem}>
                      <div>
                        <div className={styles.partName}>Display Frontal iPhone 13 <span className={styles.partStock}>Estoque: 4</span></div>
                      </div>
                      <div className={styles.partPrice}>R$ 350,00</div>
                    </div>
                    <div className={styles.partItem}>
                      <div className={styles.partName}>Mão de Obra (Técnico N2)</div>
                      <div className={styles.partPrice}>R$ 150,00</div>
                    </div>
                  </div>

                  <div className={styles.financeAction}>
                    <div className={styles.financeTotal}>
                      <span className={styles.fLabel}>Total da OS</span>
                      <span className={styles.fValue}>R$ 500,00</span>
                    </div>
                    <button className={styles.btnFaturar}>
                      <DollarSign size={16} style={{display: 'inline', marginBottom: '-3px'}}/> Faturar (Financeiro)
                    </button>
                  </div>
                  <div style={{fontSize: '0.7rem', color: '#64748b', textAlign: 'center', marginTop: '10px'}}>
                    *A peça será baixada do Módulo de Vendas automaticamente.
                  </div>
                </div>
              )}

              {/* 4. Checklist e Notas */}
              {activeMockup === 'checklist' && (
                <div className={styles.checkCard}>
                  <div className={styles.sectionTitle}>
                    <CheckSquare size={16} color="#8b5cf6"/> Checklist de Entrada
                  </div>
                  
                  <div>
                    <div className={styles.checkItem}>
                      <CheckCircle2 size={18} className={styles.checkIcon} />
                      <span className={`${styles.checkText} ${styles.done}`}>Câmera Frontal OK</span>
                    </div>
                    <div className={styles.checkItem}>
                      <CheckCircle2 size={18} className={styles.checkIcon} />
                      <span className={`${styles.checkText} ${styles.done}`}>Bateria 80%+</span>
                    </div>
                    <div className={styles.checkItem}>
                      <Square size={18} className={styles.uncheckIcon} />
                      <span className={styles.checkText}>Touchscreen Test</span>
                    </div>
                  </div>

                  <div className={styles.internalNote}>
                    <div className={styles.noteTitle}><Info size={14}/> Nota Interna (Oculta do Cliente)</div>
                    <div className={styles.noteText}>Aparelho já possui marcas de queda nas laterais. Avisei o cliente na entrada para evitar cobranças futuras.</div>
                  </div>
                </div>
              )}

            </div>
          </div>
        </div>

      </div>
    </div>
  );
}